import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../../../environments/environment';
import {IInstrument, IWorshiper} from '../../worship';

@Injectable()
export class MemberService {

    constructor(
        private _http: HttpClient,
    ) {
    }

    list(): Observable<IWorshiper[]> {
        return <any>this._http.get(`${environment.api}/worship/members`);
    }

    one(memberId: number): Observable<IWorshiper> {
        return <any>this._http.get(`${environment.api}/worship/members/${memberId}`);
    }

    save(member: IWorshiper): Observable<IWorshiper> {
        if (!!member.id) {
            return this.edit(member);
        }
        return this.add(member);
    }

    add(member: IWorshiper): Observable<IWorshiper> {
        return <any>this._http.post(`${environment.api}/worship/members`, member);
    }

    edit(member: IWorshiper): Observable<IWorshiper> {
        return <any>this._http.put(`${environment.api}/worship/members/${member.id}`, member);
    }

    remove(member: IWorshiper): Observable<IWorshiper> {
        return <any>this._http.delete(`${environment.api}/worship/members/${member.id}`);
    }

    addInstrumentTo(member: IWorshiper, instrument: IInstrument): Observable<IWorshiper> {
        return <any>this._http.put(`${environment.api}/worship/members/${member.id}/instruments`, instrument);
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/worship/team/members/member.service.ts